import { z } from 'zod';

// Device telemetry for a «Usuario», reported by the mobile app. The backend delivers the
// device object **directly** (no `{device}` envelope) in its wire shape — snake_case
// keys, `carrier` (operador) nullish. This schema mirrors that delivered shape and
// `.transform()`s it to the camelCase domain device the ficha renders. "No device" is
// signalled by an empty 200 body, handled in `endpoints/userDevice.ts` (→ null), not by
// a wrapper or a null field.
export const UserDeviceSchema = z
  .object({
    app_version: z.string(),
    os: z.string(),
    os_version: z.string(),
    model: z.string(),
    carrier: z.string().nullish(),
  })
  .transform((device) => ({
    appVersion: device.app_version,
    os: device.os,
    osVersion: device.os_version,
    model: device.model,
    carrier: device.carrier ?? null,
  }));

export type UserDevice = z.infer<typeof UserDeviceSchema>;
